import styled from 'styled-components';

export const StyledTitle = styled.span`
  font-weight: bold;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -6px;
  right: -10px;
  background: transparent;
  display: block;
  width: 20px;
  height: 20px;
  border: 0;
  cursor: pointer;
`;

export const NotificationCloseText = styled.span`
  display: inline-block;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.primary.main};
  margin-top: 20px;
  text-decoration: underline;
  cursor: pointer;
`;
